import {
  Button,
  Collapsible,
  FlexBox,
  Icon,
  Text,
} from '@dixa/lib-shared-habla';
import { useState } from 'react';

import { SidekickMessage } from '../sidekickMessage/sidekickMessage';

import styles from './sidekickPlan.module.scss';

type SidekickPlanProps = {
  plan: string;
  isLatest?: boolean;
  onStart?: () => void;
};

export const SidekickPlan = ({
  plan,
  isLatest = false,
  onStart,
}: SidekickPlanProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(isLatest);

  return (
    <div className={styles.plan}>
      <FlexBox flexDirection="column" gap="300">
        <button
          type="button"
          className={styles.toggle}
          aria-expanded={isExpanded}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <FlexBox as="span" alignItems="center" gap="200">
            <Icon name="list-ul-disc" size={16} />
            <Text.Paragraph as="span" variant="3">
              Plan
            </Text.Paragraph>
          </FlexBox>
          <Icon name={isExpanded ? 'angle-down' : 'angle-right'} size={16} />
        </button>
        <Text.Paragraph variant="4" subdued>
          Proposed changes only. Nothing has been updated.
        </Text.Paragraph>
      </FlexBox>
      <Collapsible isOpen={isExpanded} header={null}>
        <div className={styles.body}>
          <FlexBox flexDirection="column" gap="300">
            <SidekickMessage
              role="assistant"
              text={plan}
              className={styles.planText}
            />
            {isLatest && onStart && (
              <FlexBox justifyContent="flex-end">
                <Button onClick={onStart}>Carry out plan</Button>
              </FlexBox>
            )}
          </FlexBox>
        </div>
      </Collapsible>
    </div>
  );
};
